/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Disease,
    DiseaseFromJSON,
    DiseaseToJSON,
    DiseasePagination,
    DiseasePaginationFromJSON,
    DiseasePaginationToJSON,
} from '../models';

export interface DiseasesGetRequest {
    page?: number;
    itemsPerPage?: number;
    orderType?: string;
    orderBy?: string;
}

export interface DiseasesIdDeleteRequest {
    id: number;
}

export interface DiseasesIdGetRequest {
    id: number;
}

export interface DiseasesIdPutRequest {
    id: number;
    disease?: Disease;
}

export interface DiseasesPostRequest {
    disease?: Disease;
}

/**
 * 
 */
export class DiseasesApi extends runtime.BaseAPI {

    /**
     * 
     */
    diseasesGetRaw = async (requestParameters: DiseasesGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DiseasePagination>> => {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.itemsPerPage !== undefined) {
            queryParameters['itemsPerPage'] = requestParameters.itemsPerPage;
        }

        if (requestParameters.orderType !== undefined) {
            queryParameters['orderType'] = requestParameters.orderType;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/diseases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiseasePaginationFromJSON(jsonValue));
    }

    /**
     * 
     */
    diseasesGet = async (requestParameters: DiseasesGetRequest = {}, initOverrides?: RequestInit): Promise<DiseasePagination> => {
        const response = await this.diseasesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    diseasesIdDeleteRaw = async (requestParameters: DiseasesIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling diseasesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/diseases/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    diseasesIdDelete = async (requestParameters: DiseasesIdDeleteRequest, initOverrides?: RequestInit): Promise<any> => {
        const response = await this.diseasesIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    diseasesIdGetRaw = async (requestParameters: DiseasesIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Disease>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling diseasesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/diseases/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiseaseFromJSON(jsonValue));
    }

    /**
     * 
     */
    diseasesIdGet = async (requestParameters: DiseasesIdGetRequest, initOverrides?: RequestInit): Promise<Disease> => {
        const response = await this.diseasesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    diseasesIdPutRaw = async (requestParameters: DiseasesIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Disease>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling diseasesIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/diseases/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DiseaseToJSON(requestParameters.disease),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiseaseFromJSON(jsonValue));
    }

    /**
     */
    diseasesIdPut = async (requestParameters: DiseasesIdPutRequest, initOverrides?: RequestInit): Promise<Disease> => {
        const response = await this.diseasesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    diseasesPostRaw = async (requestParameters: DiseasesPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Disease>> => {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/diseases`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiseaseToJSON(requestParameters.disease),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiseaseFromJSON(jsonValue));
    }

    /**
     */
    diseasesPost = async (requestParameters: DiseasesPostRequest = {}, initOverrides?: RequestInit): Promise<Disease> => {
        const response = await this.diseasesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
